import React from 'react';
import { ConfirmationModal } from '@components/confirmation-modal';
import { Alert, AlertDescription } from '@components/ui/alert';
import { Api } from '@core/api';
import { injectTSDI } from '@core/tsdi';

type Props = {
    onSuccess: () => void;
    challengeId?: number;
    challengeName?: string;
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const ChallengeDeleteModal = ({
    onSuccess,
    challengeId,
    challengeName,
    openState: [open, setOpen]
}: Props) => {
    const { challengeClient } = injectTSDI(Api);

    const handle = async () => {
        if (challengeId) {
            await challengeClient.support.challengeSupportControllerDelete(
                challengeId
            );
            onSuccess();
        }
    };

    return (
        <ConfirmationModal
            open={open}
            submitHandler={handle}
            onModalClose={() => void setOpen(false)}
            buttonText="Delete"
            destructive
        >
            <p className="text-lg font-semibold">
                You are about to delete challenge <b>{challengeName}</b>
            </p>
            <Alert variant="warning">
                <AlertDescription>
                    Are you sure you want to delete this challenge?
                </AlertDescription>
            </Alert>
        </ConfirmationModal>
    );
};
